module.exports = __webpack_public_path__ + "static/media/kitchen-check-icon.c64ee553.png";